<template>
<div class='process-date-warning'>
  <v-flex xs10 offset-xs1 class="vf fl aic">
    <v-icon color="white" size="18" class='mr-2'>lock</v-icon>
    <p>Attentie! Op dit moment draait de schade verwerking. U kunt geen mutaties op verzuimen invoeren.</p>
  </v-flex>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProcessDatesHeaderWarning',
  computed: {
    ...mapGetters({
      processDates: 'processDates'
    })
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.process-date-warning {
  position: relative;
  position: fixed;
  background-color: $error;
  border-bottom: 1px solid #e23551;
  padding: 12px 0px;
  overflow: hidden;
  width: 100%;
  z-index: 999;
  top: 0px;

  p {
    color: white;
    z-index: 1;
  }
}
</style>
